import { render, staticRenderFns } from "./CurrencyTransaction.vue?vue&type=template&id=5619e678&scoped=true"
import script from "./CurrencyTransaction.vue?vue&type=script&lang=js"
export * from "./CurrencyTransaction.vue?vue&type=script&lang=js"
import style0 from "./CurrencyTransaction.vue?vue&type=style&index=0&id=5619e678&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5619e678",
  null
  
)

export default component.exports